const escapeRegExp = (stringToEscape) => stringToEscape.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string

export const codeAutoCompleter = (session, pos, prefix, callback, autocompletions) => {
  // Try to create a better prefix since the default one is only since after last period or other separator.
  let line = session.getLine(pos.row);
  let preLine = line.substring(0, pos.column);
  let updatedPrefix = line.substring(preLine.search(/[\w_.]*$/));
  updatedPrefix = updatedPrefix.length > prefix.length ? updatedPrefix : false;
  // Create a regex based on provided prefix
  let prefixRegex = new RegExp('[\\.(_]' + escapeRegExp(prefix));
  let completionPreWord;
  let result = [];
  function addSnippet(word) {
    result.push({
      caption: word,
      value: word,
      meta: 'snippet',
    });
  }
  let wordList = [];
  if (autocompletions) {
    wordList = autocompletions;
  }
  wordList.forEach(function (apiWord) {
    if (updatedPrefix && apiWord.includes(updatedPrefix)) {
      // If we succeeded in creating updatedPrefix and it is in the word
      completionPreWord = apiWord.substring(0, apiWord.indexOf(updatedPrefix) + updatedPrefix.length);
      if (preLine.endsWith(completionPreWord)) {
        result.push({
          caption: apiWord,
          // Adjust substring to provided prefix location
          value: apiWord.substring(completionPreWord.length - prefix.length),
          meta: 'completion',
        });
      } else {
        addSnippet(apiWord);
      }
    } else if (apiWord.search(prefixRegex) >= 0) {
      // If we find prefixRegex in the word
      completionPreWord = apiWord.substring(0, apiWord.search(prefixRegex) + prefix.length + 1);
      if (preLine.endsWith(completionPreWord)) {
        result.push({
          caption: apiWord,
          // Adjust substring to provided prefix location
          value: apiWord.substring(completionPreWord.length - prefix.length),
          meta: 'completion',
        });
      } else {
        addSnippet(apiWord);
      }
    } else if (apiWord.startsWith(prefix)) {
      // apiWord starts with exactly the provided prefix
      addSnippet(apiWord);
    }
  });
  callback(null, result);
};
